import { getCustomProperty } from '@qlik-trial/automations-ui'

export default function (name) {
  return getCustomProperty('--rgb-' + name)
}
